module.exports = __webpack_public_path__ + "static/media/panrico@2x.44e4d3b6.jpg";